function SoundCloud({ trackId }: { trackId: string }): JSX.Element {
  return (
    <iframe
      allow="autoplay"
      data-philter={`template-soundcloud-${trackId}`}
      height="166"
      src={`https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${trackId}&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true`}
      style={{ border: 0, overflow: "hidden" }}
      title={`soundcloud-${trackId}`}
      width="100%"
    />
  );
}

export default SoundCloud;
